import { Container, LayoutSpinner, Main, Sidebar, Thumbnail } from './styled';

export const Loader = () => {
  return (
    <Container>
      <Sidebar>
        {new Array(10).fill(0).map((_, i) => (
          <Thumbnail key={i} />
        ))}
      </Sidebar>
      <Main>
        <LayoutSpinner />
      </Main>
    </Container>
  );
};
